module.exports = __webpack_public_path__ + "static/media/Home_Icon3.68969840.png";